













import Vue from 'vue'

export default Vue.extend({
  props: {
    stepps: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    }
  },
})
